import React from 'react';
import { MessageCircleIcon, MicIcon, VoteIcon, CalendarIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
const useCases = [{
  icon: <MessageCircleIcon size={24} className="text-[#10b981]" data-id="element-546" />,
  title: 'Live Q&A Sessions',
  description: 'Collect questions from attendees before and during sessions. Upvote the best questions and ensure panels address what the audience truly wants to know.'
}, {
  icon: <MicIcon size={24} className="text-[#10b981]" data-id="element-547" />,
  title: 'Call for Speakers',
  description: 'Manage speaker submissions with ease. Review proposals, collaborate with your team, and communicate decisions transparently to applicants.'
}, {
  icon: <VoteIcon size={24} className="text-[#10b981]" data-id="element-548" />,
  title: 'Community Voting',
  description: 'Let your community vote on session topics, workshop ideas, and conference themes. Build an agenda that reflects what attendees want.'
}, {
  icon: <CalendarIcon size={24} className="text-[#10b981]" data-id="element-549" />,
  title: 'Workshop Proposals',
  description: 'Accept and organize workshop submissions. Track capacity, requirements, and materials all in one centralized hub.'
}, {
  icon: <UsersIcon size={24} className="text-[#10b981]" data-id="element-550" />,
  title: 'Panel Topic Suggestions',
  description: 'Gather panel discussion ideas from your community. Identify trending topics and create sessions that spark meaningful conversations.'
}, {
  icon: <TrendingUpIcon size={24} className="text-[#10b981]" data-id="element-551" />,
  title: 'Feedback Collection',
  description: 'Collect post-event feedback, session ratings, and improvement suggestions. Use insights to make each event better than the last.'
}];
export function UseCases() {
  return <section id="use-cases" className="py-20 bg-[#F5E6F5]" data-id="element-552">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-553">
        <div className="border-2 border-[#9333EA] rounded-xl p-8 bg-white/80 backdrop-blur-sm shadow-md" data-id="element-554">
          <div className="text-center mb-16 border-b border-gray-200 pb-8" data-id="element-555">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-556">
              Built for every stage of your event
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-557">
              From planning to post-event analysis, Nexio App supports event
              organizers at every step.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-558">
            {useCases.map((useCase, index) => <div key={index} className="p-6 rounded-lg shadow-md hover:shadow-lg transition-all border-2 border-[#9333EA] hover:border-[#E5B3E5] hover:bg-[#F5E6F5]" data-id="element-559">
                <div className="mb-4 p-2 inline-block bg-[#F5E6F5] rounded-lg border border-[#E5B3E5] shadow-sm" data-id="element-560">
                  {useCase.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-561">
                  {useCase.title}
                </h3>
                <div className="bg-gray-50 p-3 rounded-lg shadow-inner" data-id="element-562">
                  <p className="text-gray-600" data-id="element-563">{useCase.description}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}